<template>
  <div>
    <div class="title">
      <span class="name">{{ currentYear }}年度经营数据</span>
    </div>
    <div class="yd-content">
      <div class="line1">
        <div class="left">
          <div class="item">
            <img class="icon" src="@/assets/img/operate/yg.png" />
            <div class="content">
              <span class="label">营收计划（元）</span>
              <div class="value">
                <span>¥</span>
                <span>{{ details.planRevenueAmount }}</span>
              </div>
              <div class="desc">
                <span>同比</span>
                <span>{{ details.planYoyRevenueAmount ?? '--' }}</span>
                <img v-if="details.planYoyRevenueAmount > 0" src="@/assets/img/operate/up.png" />
                <img v-if="details.planYoyRevenueAmount < 0" src="@/assets/img/operate/down.png" />
              </div>
            </div>
          </div>
          <div class="item">
            <img class="icon" src="@/assets/img/operate/yg.png" />
            <div class="content">
              <span class="label">实际成本（元）</span>
              <div class="value">
                <span>¥</span>
                <span>{{ details.actualCostAmount ?? '--' }}</span>
              </div>
              <div class="desc">
                <span>较计划</span>
                <span>{{ Math.abs(details.actualToPlanCostAmount) }}</span>
                <img v-if="details.actualToPlanCostAmount > 0" src="@/assets/img/operate/up.png" />
                <img v-if="details.actualToPlanCostAmount < 0" src="@/assets/img/operate/down.png" />
              </div>
            </div>
          </div>
          <div class="item">
            <img class="icon" src="@/assets/img/operate/yg.png" />
            <div class="content">
              <span class="label">实际利润（元）</span>
              <div class="value">
                <span>¥</span>
                <span>{{ details.actualProfitAmount ?? '--' }}</span>
              </div>
              <div class="desc">
                <span>较计划</span>
                <span>{{ Math.abs(details.actualToPlanProfitAmount) }}</span>
                <img v-if="details.actualToPlanProfitAmount > 0" src="@/assets/img/operate/up.png" />
                <img v-if="details.actualToPlanProfitAmount < 0" src="@/assets/img/operate/down.png" />
              </div>
            </div>
          </div>
          <div class="item">
            <img class="icon" src="@/assets/img/operate/yg.png" />
            <div class="content">
              <span class="label">实际利润率</span>
              <div class="value">
                <span>{{ details.actualProfitPer ?? '--' }}%</span>
              </div>
              <div class="desc">
                <span>较计划</span>
                <span>{{ Math.abs(details.actualToPlanProfitPer) }}%</span>
                <img v-if="details.actualToPlanProfitPer > 0" src="@/assets/img/operate/up.png" />
                <img v-if="details.actualToPlanProfitPer < 0" src="@/assets/img/operate/down.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="item">
            <div class="content">
              <span class="label">应回款额（元）</span>
              <div class="value">
                <span>¥</span>
                <span>{{ details.planBackAmount }}</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="content">
              <span class="label">已回款额（元）</span>
              <div class="value">
                <span>¥</span>
                <span>{{ details.actualBackAmount ?? '--' }}</span>
              </div>
              <div class="desc">
                <span>较计划</span>
                <span>{{ Math.abs(details.actualToPlanBackAmount) }}</span>
                <img v-if="details.actualToPlanBackAmount > 0" src="@/assets/img/operate/up.png" />
                <img v-if="details.actualToPlanBackAmount < 0" src="@/assets/img/operate/down.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line2">
        <div class="chart-item">
          <div class="chart-title">
            <span class="name">实际成本分类占比</span>
          </div>
          <div class="chart-content" id="chart3"></div>
        </div>
        <div class="chart-item">
          <div class="chart-title">
            <span class="name">计划与实际成本偏差对比</span>
          </div>
          <div class="chart-content" id="chart4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chartMixin from '@/mixins/mixin'
export default {
  name: 'Section3',
  mixins: [chartMixin],
  data() {
    return {
      currentYear: '',
      details: {
        planRevenueAmount: '', // 营收计划金额
        actualCostAmount: '', // 实际成本金额
        planCostAmount: '', // 计划成本金额
        actualToPlanCostAmount: '', // 实际较计划成本差值金额
        actualProfitAmount: '', // 实际利润金额
        planProfitAmount: '', // 计划利润金额
        actualToPlanProfitAmount: '', // 实际较计划利润差值金额
        actualProfitPer: '', // 实际利润率
        planProfitPer: '', // 计划利润率
        actualToPlanProfitPer: '', // 实际较计划利润率差值
        planYoyRevenueAmount: '', // 年营收计划同比差值金额【年经营数据】
        actualBackAmount: '', // 实际回款金额【年经营数据】
        planBackAmount: '', // 计划回款金额【年经营数据】
        actualToPlanBackAmount: '', // 实际较计划回款差值金额【年经营数据】
        waitBackAmount: '', // 待回款金额【开累经营数据】
        waitToPlanBackAmount: '', // 待回款较计划回款差值金额【开累经营数据】
        actualCostTypePerList: [], // 实际成本分类占比数组(顺序：人、机、材、间)
        actualCostTypeAmountList: [], // 实际成本分类金额数组(顺序：人、机、材、间)
        planCostTypeAmountList: [], // 计划成本分类金额数组(顺序：人、机、材、间)
        actualCostTypeContractPerList: [], // 实际成本分类在合同中占比数组【开累经营数据】(顺序：人、机、材、间)
        backYearList: [], // 回款年份列表【开累经营数据】
        actualBackAmountList: [], // 实际回款金额列表【开累经营数据】
        planBackAmountList: [] // 计划回款金额列表【开累经营数据】
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // do something
    this.$event.$on('projectSearchChange', this.loadData)
  },
  beforeDestroy() {
    this.$event.$off('projectSearchChange')
  },
  methods: {
    loadData(searchForm) {
      this.currentYear = this.$dayjs(searchForm.yearMonth).format('YYYY')
      this.$axios.get(this.$apis.operate.selectCurrentYear, {
        projectId: searchForm.projectId,
        year: this.currentYear
      }).then(res => {
        this.details = res
        this.$nextTick(() => {
          this.initChart1()
          this.initChart2()
        })
      })
    },
    initChart1() {
      const chart = this.$getChartInstance('#chart3')
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}%'
        },
        legend: {
          show: false,
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 20,
          right: 80,
          top: 'center',
          orient: 'vertical'
        },
        color: ['#47A2FF', '#1AD1B0', '#FBD44C', '#F3657C'],
        series: [
          {
            type: 'pie',
            radius: ['55%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              show: false,
              position: 'center', // 标签显示在外部
              alignTo: 'edge',
              formatter: '{b}\n{d}%'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: this.details.actualCostTypePerList[0], name: '人力成本' },
              { value: this.details.actualCostTypePerList[1], name: '机械成本' },
              { value: this.details.actualCostTypePerList[2], name: '材料成本' },
              { value: this.details.actualCostTypePerList[3], name: '间接费' }
            ]
          }
        ]
      };
      chart.clear()
      chart.setOption(option)
    },
    initChart2() {
      const chart = this.$getChartInstance('#chart4')
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              // 显示系列名称、图例颜色和数据信息
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
            }
            return tooltipStr;
          }
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true
        },
        yAxis: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: ['人力成本', '机械成本', '材料成本', '间接费'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 16,
            color: '#7F8FA4'
          }
        },
        series: [
          {
            name: '计划',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: '#0D4789',
            },
            data: this.details.planCostTypeAmountList
          },
          {
            name: '实际',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#FAD961' }, // 起始颜色
                { offset: 0, color: '#FF8C4A' } // 结束颜色
              ]),
            },
            data: this.details.actualCostTypeAmountList
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  height: 60px;
  border-bottom: 1px solid #E8E8E8;
  padding: 0 24px;
  display: flex;
  align-items: center;

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
}

.yd-content {
  padding: 20px 20px 15px 24px;

  .line1 {
    display: flex;

    .left {
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      .item {
        display: flex;
        width: 50%;

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }

        .content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }

          .value {
            display: flex;
            align-items: flex-end;
            margin-top: 13px;

            span {
              &:first-child {
                font-size: 20px;
                margin-right: 10px;
                line-height: 32px;
              }

              &:last-child {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #354052;
                line-height: 32px;
                text-align: left;
                font-style: normal;
              }
            }
          }

          .desc {
            display: flex;
            align-items: center;
            margin-top: 13px;

            span {
              &:nth-child(1) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #7F8FA4;
                line-height: 24px;
                text-align: left;
                font-style: normal;
              }

              &:nth-child(2) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #354052;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                margin-left: 10px;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }
        }
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      padding: 30px 20px;
      width: 253px;
      height: 266px;
      background: linear-gradient(180deg, #FAFAFA 0%, #F6F6F6 100%);
      border-radius: 6px;

      .item {
        display: flex;

        &:nth-child(n + 2) {
          margin-top: 30px;
        }

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }

        .content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }

          .value {
            display: flex;
            align-items: flex-end;
            margin-top: 13px;

            span {
              &:first-child {
                font-size: 20px;
                margin-right: 10px;
                line-height: 32px;
              }

              &:last-child {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #354052;
                line-height: 32px;
                text-align: left;
                font-style: normal;
              }
            }
          }

          .desc {
            display: flex;
            align-items: center;
            margin-top: 13px;

            span {
              &:nth-child(1) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #7F8FA4;
                line-height: 24px;
                text-align: left;
                font-style: normal;
              }

              &:nth-child(2) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #354052;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                margin-left: 10px;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }

  .line2 {
    display: flex;
    margin-top: 34px;
    height: 250px;

    .chart-item {
      display: flex;
      flex-direction: column;

      &:nth-child(1) {
        flex: 1;
      }

      &:nth-child(2) {
        width: 430px;
        margin-left: 50px;
      }

      .chart-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #E8E8E8;

        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          line-height: 24px;
          text-align: left;
          font-style: normal;
        }
      }

      .chart-content {
        flex: 1;
      }
    }
  }
}
</style>
